import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../../../translations';
import { MedicalLeaveCommonFormsBean } from '../../common.types';

type HouseFieldProps = Pick<FormContextValues<MedicalLeaveCommonFormsBean>, 'register'>;

export const HouseField = (props: HouseFieldProps): JSX.Element => {
   return (
      <TextInput
         controller={props.register('address.house', {
            required: true,
            maxLength: 50,
         })}
         label={commonTranslationKeys.houseNo}
         testId={'house'}
         className={'house'}
      />
   );
};
